"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertionApply = void 0;
const Cores = __importStar(require("../core"));
const Errors = __importStar(require("../errors"));
const readback_1 = require("../readback");
const solution_1 = require("../solution");
function insertionApply(mod, ctx, insertion, core) {
    switch (insertion["@kind"]) {
        case "InsertionPatternVar": {
            const argValue = (0, solution_1.solutionLookupValue)(mod.solution, insertion.patternVar.neutral.name);
            if (argValue === undefined) {
                if (insertion.argExp !== undefined) {
                    throw new Errors.ElaborationError([
                        `[insertionApply] meet unsolved pattern variable during infer`,
                        `  variable name: ${insertion.patternVar.neutral.name}`,
                        `  kind of next arg exp: ${insertion.argExp["@kind"]}`,
                    ].join("\n"), { span: insertion.argExp.span });
                }
                else {
                    throw new Errors.ElaborationError([
                        `[insertionApply] meet unsolved pattern variable during check`,
                        `  variable name: ${insertion.patternVar.neutral.name}`,
                    ].join("\n"), {});
                }
            }
            const argCore = (0, readback_1.readback)(mod, ctx, insertion.patternVar.type, argValue);
            return Cores.ApImplicit(core, argCore);
        }
        case "InsertionUsedArg": {
            return Cores.Ap(core, insertion.argCore);
        }
        case "InsertionImplicitArg": {
            return Cores.ApImplicit(core, insertion.argCore);
        }
    }
}
exports.insertionApply = insertionApply;
//# sourceMappingURL=insertionApply.js.map